import { gql } from '@apollo/client';

export const CREATE_PRESCRIPTION_FROM_TEMPLATE = gql`
  mutation createPrescriptionFromTemplate($careplanId: ID!, $templateId: ID!, $selectionMethod: String) {
    createPrescriptionFromTemplate(
      careplanId: $careplanId
      templateId: $templateId
      selectionMethod: $selectionMethod
    ) {
      prescription {
        id
      }
    }
  }
`;

export const CREATE_PRESCRIPTION_FROM_MANUAL_SITE = gql`
  mutation createPrescriptionFromManualSite($careplanId: ID!, $treatmentSite: String!, $treatmentSiteSpecify: String!) {
    createPrescriptionFromManualSite(
      careplanId: $careplanId
      treatmentSite: $treatmentSite
      treatmentSiteSpecify: $treatmentSiteSpecify
    ) {
      prescription {
        id
      }
    }
  }
`;

export const TEMPLATE_FILTER_LIST = gql`
  query templateFilterList(
    $tumourStream: String!
    $siteFilter: String
    $doseFilter: String
    $techniqueFilter: String
    $patientId: ID!
  ) {
    templateFilterList(
      tumourStream: $tumourStream
      siteFilter: $siteFilter
      doseFilter: $doseFilter
      techniqueFilter: $techniqueFilter
      patientId: $patientId
    ) {
      siteFilter
      doseFilter
      techniqueFilter
    }
  }
`;

export const LIST_CAREPLAN_FILTERS = gql`
  query careplanTemplateList(
    $patientId: ID!
    $tumourStream: String!
    $siteFilter: String
    $doseFilter: String
    $techniqueFilter: String
    $search: String
    $hasOar: Boolean
  ) {
    careplanTemplateList(
      patientId: $patientId
      tumourStream: $tumourStream
      siteFilter: $siteFilter
      doseFilter: $doseFilter
      techniqueFilter: $techniqueFilter
      search: $search
      hasOar: $hasOar
    ) {
      id
      name
      rules {
        id
        field
        defaultValue
      }
    }
  }
`;

export const LIST_TUMOUR_STREAMS = gql`
  query tumourStreamList {
    tumourStreamList
  }
`;

export const LIST_TREATMENT_SITES_ORDERBY_USAGE = gql`
  query mostUsedSiteReferenceList {
    mostUsedSiteReferenceList {
      id
      treatmentSite
    }
  }
`;

export const GET_TUMOUR_STREAM_FROM_CAREPLAN = gql`
  query careplan($careplanId: ID!) {
    careplan(id: $careplanId) {
      id
      practitioner {
        id
      }
      diagnosis {
        id
        diagnosisCode {
          id
          diagnosisCode
          tumourStream {
            id
            name
          }
        }
        isPrimaryDiagnosis
        relatedPrimaryDiagnosis {
          id
          diagnosisCode {
            id
            tumourStream {
              id
              name
            }
          }
        }
      }
    }
  }
`;
